const testNetworksDetails = [
  {
    title: "Redes de Prueba Populares (Testnets)",
    value: `
A continuación se presentan algunas de las **testnets** más usadas en el ecosistema blockchain, incluyendo sus principales características y enlaces útiles:

---

### **Arbitrum Goerli Testnet (Ethereum L2)**
- **Símbolo:** AGoerliETH  
- **Propósito:** Pruebas en Layer 2 de Ethereum  
- **Explorer:** [goerli.arbiscan.io](https://goerli.arbiscan.io)  
- **Faucet:** [faucet.quicknode.com/arbitrum/goerli](https://faucet.quicknode.com/arbitrum/goerli)  
- **RPC URL:** \`https://goerli-rollup.arbitrum.io/rpc\`
- **Chain ID:** 421613
- **Símbolo de moneda:** ETH  
- **Descripción:** Permite testear aplicaciones en Arbitrum, una solución de escalabilidad para Ethereum.
- **Estado:** Activa

---

### **Avalanche Fuji C-Chain Testnet**
- **Símbolo:** AVAX  
- **Propósito:** Red de pruebas para Avalanche  
- **Explorer:** [testnet.snowtrace.io](https://testnet.snowtrace.io)  
- **Faucet:** [faucet.avax.network](https://faucet.avax.network)  
- **RPC URL:** \`https://api.avax-test.network/ext/bc/C/rpc\`
- **Chain ID:** 43113
- **Símbolo de moneda:** AVAX  
- **Descripción:** Red de pruebas para aplicaciones y contratos en la Avalanche C-Chain.
- **Estado:** Activa

---

### **Base Goerli Testnet**
- **Símbolo:** ETH  
- **Propósito:** Red de pruebas para la Layer 2 de Coinbase  
- **Explorer:** [goerli.basescan.org](https://goerli.basescan.org)  
- **Faucet:** [faucet.quicknode.com/base/goerli](https://faucet.quicknode.com/base/goerli)  
- **RPC URL:** \`https://goerli.base.org\`
- **Chain ID:** 84531
- **Símbolo de moneda:** ETH  
- **Descripción:** Permite testear aplicaciones sobre la L2 de Coinbase antes de ir a mainnet.
- **Estado:** Activa

---

### **BNB Smart Chain Testnet**
- **Símbolo:** tBNB  
- **Propósito:** Red de prueba de Binance Smart Chain  
- **Explorer:** [testnet.bscscan.com](https://testnet.bscscan.com)  
- **Faucet:** [testnet.binance.org/faucet-smart](https://testnet.binance.org/faucet-smart)  
- **RPC URL:** \`https://data-seed-prebsc-1-s1.binance.org:8545\`
- **Chain ID:** 97
- **Símbolo de moneda:** tBNB  
- **Descripción:** Ideal para probar contratos BEP-20 en la red BNB antes de moverlos a mainnet.
- **Estado:** Activa

---

### **Ethereum Holesky Testnet**
- **Símbolo:** HETH  
- **Propósito:** Testnet pública a gran escala para Ethereum  
- **Explorer:** [holesky.etherscan.io](https://holesky.etherscan.io)  
- **Faucet:** [quicknode.com/ethereum/holesky](https://faucet.quicknode.com/ethereum/holesky)  
- **RPC URL:** \`https://ethereum-holesky.publicnode.com\`
- **Chain ID:** 17000
- **Símbolo de moneda:** HETH  
- **Descripción:** Red de pruebas que busca reemplazar a Goerli con un mayor suministro de tokens y nodos.
- **Estado:** Activa

---

### **Ethereum Sepolia Testnet**
- **Símbolo:** SEP  
- **Propósito:** Red oficial de pruebas de Ethereum  
- **Explorer:** [sepolia.etherscan.io](https://sepolia.etherscan.io)  
- **Faucet:** [faucet.quicknode.com/ethereum/sepolia](https://faucet.quicknode.com/ethereum/sepolia)  
- **RPC URL:** \`https://rpc.sepolia.org\`
- **Chain ID:** 11155111
- **Símbolo de moneda:** SEP  
- **Descripción:** Sepolia es la red de pruebas recomendada por Ethereum para simular contratos y transacciones sin costo. Compatible con wallets como MetaMask y Enkrypt.
- **Estado:** Activa

---

### **Linea Testnet**
- **Símbolo:** ETH  
- **Propósito:** Red de pruebas de la L2 de ConsenSys  
- **Explorer:** [explorer.goerli.linea.build](https://explorer.goerli.linea.build)  
- **Faucet:** [faucet.quicknode.com/linea/goerli](https://faucet.quicknode.com/linea/goerli)  
- **RPC URL:** \`https://rpc.goerli.linea.build\`
- **Chain ID:** 59140
- **Símbolo de moneda:** ETH  
- **Descripción:** Permite probar aplicaciones sobre la red Linea, una solución zkEVM desarrollada por ConsenSys.
- **Estado:** Activa

---

### **Optimism Goerli Testnet**
- **Símbolo:** ETH  
- **Propósito:** Testnet para la Layer 2 Optimism  
- **Explorer:** [goerli-optimism.etherscan.io](https://goerli-optimism.etherscan.io)  
- **Faucet:** [faucet.quicknode.com/optimism/goerli](https://faucet.quicknode.com/optimism/goerli)  
- **RPC URL:** \`https://goerli.optimism.io\`
- **Chain ID:** 420
- **Símbolo de moneda:** ETH  
- **Descripción:** Prueba aplicaciones y contratos en Optimism antes de ir a la red principal.
- **Estado:** Activa

---

### **Polygon Amoy Testnet**
- **Símbolo:** MATIC  
- **Propósito:** Red de pruebas para Polygon  
- **Explorer:** [oklink.com/amoy](https://www.oklink.com/amoy)  
- **Faucet:** [faucet.polygon.technology](https://faucet.polygon.technology)  
- **RPC URL:** \`https://rpc-amoy.polygon.technology\`
- **Chain ID:** 80002
- **Símbolo de moneda:** POL  
- **Descripción:** Amoy es la testnet más reciente de Polygon para probar contratos y DApps antes de llevarlas a mainnet.
- **Estado:** Activa

---

### **Polygon Mumbai Testnet**
- **Símbolo:** MATIC  
- **Propósito:** Antigua red de pruebas para Polygon  
- **Explorer:** [mumbai.polygonscan.com](https://mumbai.polygonscan.com)  
- **Faucet:** [faucet.polygon.technology](https://faucet.polygon.technology)  
- **RPC URL:** \`https://rpc-mumbai.maticvigil.com\`
- **Chain ID:** 80001
- **Símbolo de moneda:** MATIC  
- **Descripción:** Fue la testnet oficial de Polygon antes de Amoy, ahora está siendo migrada y desfasada gradualmente.
- **Estado:** Deprecada

---

#### **¿Cómo agregar Polygon Amoy Testnet a MetaMask?**

1. Abre MetaMask y haz clic en el menú de selección de red.
2. Selecciona **Agregar red** o **Agregar una red personalizada**.
3. Rellena los siguientes campos:
    - **Nombre de la red:** Polygon Amoy Testnet
    - **URL RPC por defecto:** https://rpc-amoy.polygon.technology
    - **Identificador de cadena (Chain ID):** 80002
    - **Símbolo de moneda:** POL
    - **URL del explorador de bloques:** https://amoy.polygonscan.com
4. Haz clic en **Guardar**.
5. ¡Listo! Ya puedes usar la testnet Amoy en MetaMask.

---

### Otras redes como Solana y Starknet requieren configuraciones especiales fuera de MetaMask.
`
  }
];

export default testNetworksDetails;
